// extracted by mini-css-extract-plugin
export default {"closeButton":"ModalAvatar_closeButton__HaxG4","image":"ModalAvatar_image__M1i+L","inner":"ModalAvatar_inner__miTs6"};